import image1 from '@/assets/images/news/detail/20200214/1.jpg';
import image2 from '@/assets/images/news/detail/20200214/2.jpg';

export default {
  id: '20200214',
  title: '抗疫保民生 叮咚买菜配送升级提升运力',
  origin: '2020-02-14 11:56:00 来源：央广网',
  editor: '编辑： 林馥榆',
  content: [
    {
      type: 0,
      text:
        '央广网上海2月14日消息（记者吴善阳）受疫情影响，上海市民们纷纷响应号召减少外出，每天的买菜难题都通过叮咚买菜等手机app来解决，在家就能轻轻松松收菜。面对极速增长的买菜需求，生鲜电商如何在疫情之下快速解决运力瓶颈？升级更高效的配送车辆是解决问题的良方。带着这样的需求，叮咚买菜找到蔚来，双方迅速展开合作，让送菜小哥“鸟枪换炮”开着汽车去送菜，大大提升了配送效率，满足了更多市民买菜的需求。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜CEO梁昌霖表示，疫情期间，市民们的生活受到极大的影响，为了更好地保障市民们的吃菜需求，近日与蔚来展开合作，测试配送新模式，解决运力瓶颈。并且，这种新的合作模式将不仅仅局限于此次疫情期间，以后在任何需要应急的时期，比如节假日高峰期，都可以启用。',
      isIndent: false,
    },
    {
      type: 1,
      title: ['配送小哥开汽车送菜  服务用户增加了70%（央广网发 叮咚买菜提供）'],
      src: [image1],
    },
    {
      type: 0,
      text:
        '据了解，今年是叮咚买菜第三年实行春节不打烊，1万多名配送小哥坚守在一线，但仍然供不应求，春节单量高峰期期间，很多小哥甚至要坚持配送到半夜一两点，才能把用户的订单送完。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '而且疫情期间，大家往往一次下单就囤很多天的食物，一位上海用户曾下过一个“最重订单”，一次性买了76件商品，包括6袋米、2桶食用油、3箱牛奶，还有各种蔬菜、零食、水果、速食品。这种订单往往需要小哥多次往返才能送完，效率很低。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '合作启动后，蔚来为叮咚买菜免费提供8辆智能电动旗舰SUV ES8进行新模式配送试运营，随后以极优惠的价格将更多车辆租给叮咚，保障民生需求。目前已投入使用了12辆ES8，分别投放到叮咚买菜12个前置仓。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '试运营站点的配送小哥周小虎说：“春节期间，我们用电瓶车送单，一次性最多只能送20单，现在一次能送80~100单。蔚来加入后，也更快了，之前爆单的时候，我们有时候甚至要送到半夜1点才送得完，现在我们基本9、10点就可以送完。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在叮咚买菜的联洋区域的一个前置仓，站长告诉记者：“之前，我们仓1天能够服务近1000个用户，在使用了汽车之后，一天能配送1700多位用户的订单。服务的客户增加了70%。让更多用户更快地买到菜，我们也很高兴。”',
      isIndent: false,
    },
    {
      type: 1,
      title: [
        '开发新的集约式配送方式  新算法解决调度难题  （央广网发 叮咚提供）',
      ],
      src: [image2],
    },
    {
      type: 0,
      text:
        '蔚来将车辆派往叮咚买菜前置仓之初，发现派送单量并没有比电瓶车高很多，大运载量配送的优势没有得以体现。原来通过电瓶车快速、少量派送订单的模式，并不适合汽车配送。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '以前，叮咚买菜实行的是半小时内送达，为了保证速度，订单分配系统往往是接到几单后就分配给小哥，通过电瓶车迅速进行配送。在疫情特殊时期，居家用户对于订单配送即时性的要求有所降低，为响应变化提高效率，叮咚买菜及时开发新算法，优化订单分配系统，采取集约化配送方式，一次性累积100单左右，再通过系统派单给到蔚来汽车配送，大大提升了运力和效率。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '原本，叮咚买菜一个配送员一天可以送七八十单，改变分配模式和单次运载的量后，一个配送员一天就可以配送150单左右，大大提升了人效。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据了解，在今年春节期间，叮咚买菜坚持不打烊、不涨价、不断货，坚持服务市民。梁昌霖表示，我们一位骑手送一天的菜，能给100多个家庭送菜，减少100多个家庭的出行。减少市民的出行，也是给抗击疫情作了贡献。我们还通过各种新的模式，不断提升配送效率，尽量给更多家庭把蔬菜、肉禽蛋、水果、早餐送到家，服务大家的最后一公里。',
      isIndent: false,
    },
  ],
};
